import { motion } from "framer-motion";
import { Mic, Sparkles, CircleCheckBig } from "lucide-react";

const STEPS = [
  {
    n: "01",
    icon: Mic,
    title: "Tell GoDiGo what you need",
    body: "Speak or type naturally: \"Book a dentist appointment Thursday and remind me the night before.\" No forms, no menus.",
  },
  {
    n: "02",
    icon: Sparkles,
    title: "GoDiGo understands and organizes it",
    body: "It parses your intent, creates the right tasks, reminders and calendar events, and files everything where it belongs.",
  },
  {
    n: "03",
    icon: CircleCheckBig,
    title: "Stay on top of everything",
    body: "Timely nudges, a clear Today view and synced calendars keep your whole life running — without the mental load.",
  },
];

export default function HowItWorks() {
  return (
    <section id="how-it-works" className="relative bg-[#1B4D3E] py-20 text-white lg:py-32" data-testid="how-it-works-section">
      <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: "-80px" }}
          transition={{ duration: 0.7 }}
        >
          <p className="overline-label !text-lime-300">How it works</p>
          <h2 className="mt-3 max-w-2xl font-heading text-3xl font-bold tracking-tight sm:text-4xl lg:text-5xl">
            From <span className="font-serif-accent italic text-lime-300">spoken thought</span> to done. In three steps.
          </h2>
        </motion.div>

        <div className="mt-16 grid grid-cols-1 gap-6 md:grid-cols-3">
          {STEPS.map((s, i) => (
            <motion.div
              key={s.n}
              data-testid={`how-it-works-step-${i + 1}`}
              initial={{ opacity: 0, y: 40 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, margin: "-60px" }}
              transition={{ duration: 0.65, delay: i * 0.15 }}
              className="group relative rounded-3xl border border-white/10 bg-white/5 p-8 backdrop-blur-sm transition-colors duration-300 hover:bg-white/10"
            >
              <span className="font-mono-accent text-5xl font-medium text-lime-300/30 transition-colors duration-300 group-hover:text-lime-300/60">{s.n}</span>
              <div className="mt-6 flex h-11 w-11 items-center justify-center rounded-2xl bg-lime-300 text-[#143B2F]">
                <s.icon size={20} />
              </div>
              <h3 className="mt-5 font-heading text-xl font-bold">{s.title}</h3>
              <p className="mt-3 text-sm leading-relaxed text-emerald-100/85">{s.body}</p>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
}
